module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("CONTENTS")])])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('p', {
    staticClass: "toch"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/intro"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0004-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toch"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("WELCOME TO QO’NOS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01aa#ch01lev01"
    }
  }, [_vm._v("GETTING HERE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01aa#ch01lev02"
    }
  }, [_vm._v("USING THIS GUIDE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01aa#ch01lev03"
    }
  }, [_vm._v("TIPS FOR A FUN TRIP")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01aa#ch01lev04"
    }
  }, [_vm._v("WHAT TO WEAR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01aa#ch01lev05"
    }
  }, [_vm._v("LODGING TIPS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01aa#ch01lev06"
    }
  }, [_vm._v("ETIQUETTE")])]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0004-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch01sub01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("THE KLINGON EMPIRE: A BRIEF HISTORY FOR VISITORS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch01sub01#ch01lev07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EARLY HISTORY, EARLY CHAOS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch01sub01#ch01lev08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE RISE OF KAHLESS THE UNFORGETTABLE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch01sub01#ch01lev09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EXPANSION AND CONQUEST")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch01sub01#ch01lev10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CONTACT WIITH EARTH AND THE FEDERATION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch01sub01#ch01lev11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE EMPIRE TODAY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch01sub02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("tlhIngan Hol!")]), _vm._v(" "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("DO YOU SPEAK IT?: A KLINGON LANGUAGE PRIMER")])])]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0004-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("THE FIRST CITY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch02aa#ch02lev01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GETTING AROUND")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch02aa#ch02lev02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SIGHTS AND ACTIVITIES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch02aa#ch02lev03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SHOPPING AND ENTERTAINMENT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch02aa#ch02lev04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DINING AND NIGHTLIFE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch02aa#ch02lev05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LODGING")])]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0004-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("THE CENTRAL PLAINS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03aa#ch03lev01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GETTING AROUND")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03aa#ch03lev02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SIGHTS AND ACTIVITIES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03aa#ch03lev03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SHOPPING AND ENTERTAINMENT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03aa#ch03lev04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DINING AND NIGHTLIFE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03aa#ch03lev05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LODGING")])]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0004-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03sub01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("SIDE TRIP: KHITOMER")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03sub01#ch03lev06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GETTING AROUND")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03sub01#ch03lev07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SIGHTS AND ACTIVITIES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03sub01#ch03lev08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SHOPPING AND ENTERTAINMENT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03sub01#ch03lev09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DINING")])]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0005-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("KRENNLA")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04aa#ch04lev01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GETTING AROUND")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04aa#ch04lev02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SIGHTS AND ACTIVITIES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/ch04aa#ch04lev03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SHOPPING AND ENTERTAINMENT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04aa#ch04lev04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DINING AND NIGHTLIFE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04aa#ch04lev05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LODGING")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04sub01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("SIDE TRIP: RURA PENTHE")])])]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0005-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("KETHA PROVINCE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05aa#ch05lev01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GETTING AROUND")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05aa#ch05lev02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SIGHTS AND ACTIVITIES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05aa#ch05lev03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SHOPPING AND ENTERTAINMENT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05aa#ch05lev04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DINING AND NIGHTLIFE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05aa#ch05lev05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LODGING")])]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0005-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05sub01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("SIDE TRIP: NARENDRA III")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05sub01#ch05lev06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GETTING AROUND")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05sub01#ch05lev07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SIGHTS AND ACTIVITIES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05sub01#ch05lev08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SHOPPING AND ENTERTAINMENT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05sub01#ch05lev09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DINING")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05sub01#ch05lev10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LODGING")])]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0005-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("QUIN’LAT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06aa#ch06lev01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GETTING AROUND")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06aa#ch06lev02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SIGHTS AND ACTIVITIES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06aa#ch06lev03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SHOPPING AND ENTERTAINMENT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06aa#ch06lev04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DINING AND NIGHTLIFE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06aa#ch06lev05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LODGING")])]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0005-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06sub01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("SIDE TRIP: BORETH")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06sub01#ch06lev06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GETTING AROUND")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06sub01#ch06lev07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SIGHTS AND ACTIVITIES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06sub01#ch06lev08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SHOPPING AND ENTERTAINMENT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06sub01#ch06lev09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DINING")])]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0005-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("TONG VEY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07aa#ch07lev01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GETTING AROUND")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07aa#ch07lev02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SIGHTS AND ACTIVITIES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07aa#ch07lev03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SHOPPING AND ENTERTAINMENT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07aa#ch07lev04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DINING AND NIGHTLIFE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07sub02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("SEEK YOUR OWN")]), _vm._v(" "), _c('span', {
    staticClass: "txbfit"
  }, [_vm._v("VENGEANCE!")])])]), _vm._v(" "), _c('p', {
    staticClass: "tochq"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "tochq"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/sources",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("SOURCES")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ee67910","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/cont.vue
// module id = 60
// module chunks = 0